import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import App from '@bitComponents/unifiedComponents/AppController';
import Modal from '@bitComponents/unifiedComponents/Modal';
import { CONTENT, THEMES } from '@bitComponents/unifiedComponents/Stopper';
import URL_LIBRARY from '../config/pages/urlLibrary.json';
import { modules } from '../config/pages/modules';
import rootReducers from './reducers/index';
import rootSaga from './sagas/index';
import '../config/styles/globalVars.css';
import './main.scss';
/* [STYLES] begins */
import '../styles/text.raw.styles.css';
/* [STYLES] ends */
const mainSetup = require('../config/mainSetup');
/*
  it seems unnecesary but regular behaviour it transform json to object,
  and we actually wants an array
*/
const urlLibrary = URL_LIBRARY;
/* checking incons styles  */
const ICONS_CSS_FILENAME = 'https://prod.cms.col.movistar.es/static/fonts/icon/icons.min.css?cache=040720221337';
const loadCssIcons = () => {
  let isAlreadyLoaded = false;
  const ss = document.styleSheets;
  for (let i = 0, max = ss.length; i < max; i += 1) {
    if (ss[i].href === ICONS_CSS_FILENAME) {
      isAlreadyLoaded = true;
      break;
    }
  }
  if (!isAlreadyLoaded) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.async = 'async';
    link.defer = 'defer';
    link.href = ICONS_CSS_FILENAME;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
};

loadCssIcons();

ReactDOM.render(
  <Fragment>
    <App
      projectId={mainSetup.projectId}
      urlLibrary={urlLibrary}
      modulesLibrary={modules}
      rootReducers={rootReducers}
      rootSagas={rootSaga}
      reduxTools={REDUXTOOLS || localStorage.getItem('REDUX_ALLOWED')}
      ModalComponent={Modal}
      defaultErrorScreen={{
        theme: THEMES.BEACH,
        content: CONTENT.ERROR,
        contentProps: {
          msg: ['Uppss... algo ha ido mal.', 'Por favor, inténtalo más tarde.'],
          errorName: 'error generico',
        },
      }}
    />
  </Fragment>,
  document.getElementById(`${mainSetup.projectId}-content`),
);

// Check if hot reloading is enable. If it is, changes won't reload the page.
// This is related to webpack-dev-server and works on development only.
if (module.hot) {
  module.hot.accept();
}
